/**
 * Gestion des langues dans l'application.
 *
 * Il suffit d'appeler la méthode __ pour traduire un message
 *
 * @version 1.1
 * @author Damien Cuvillier
 * @copyright All right Reserved to Gotan
 */


/** Traduit un message dans la langue locale.
 * @param code code du message à traduire
 * @param parameters tableau des paramètres
 */
const __ = function (code, parameters) {
    return gkjs.i18n.getMessage(code, parameters);
};

let gkjs;
if (typeof gkjs === 'undefined') {
    gkjs = {};
}

gkjs.i18n = {
    _settings: {
        /* Répertoire où se trouvent les fichiers de langue. */
        basePath: '/lang/',
        /** Langue par défaut utilisé si le fichier de langue demandé n'est pas trouvé. */
        defaultLanguage: 'fr'
    },
    _data: {},
    getLang: function () {
        let lang;
        if (window.localStorage == null || window.localStorage.lang == null) {
            if (navigator.language == null) {
                lang = this._settings.defaultLanguage;
            } else {
                lang = navigator.language;
            }
        } else {
            lang = window.localStorage.lang;
        }

        if (lang.indexOf('-') !== -1) {
            lang = lang.substring(0, lang.indexOf('-'));
        }
        return lang.toLowerCase();
    },

    changeListeners: [],

    addChangeListener: function(listener){
        this.changeListeners.push(listener);
    },
    onChange: function(){
        let lang = this.getLang();
        this.changeListeners.forEach(l => l(lang));
    },
    /** Récupère un message à partir de son code.
     *   - Si le message n'est pas trouvé, alors on essaye de récupérer dans la langue par défaut
     *   - Si le message n'est pas disponible, alors on renvoie son code
     *
     * Tous les messages manquants sont loggés en console
     * @param messageCode du message
     * @param parameters Tableau ordonné des paramètres
     * @param lang Langue à récupérer. Si non précisé, alors on prend la langue définie dans l'application
     */
    getMessage: function (messageCode, parameters, lang) {
        if (lang == null) {
            lang = this.getLang();
        }
        if (this._data[lang] == null) {
            this.loadLanguage(lang);
            return messageCode;
        }
        if (messageCode == null) {
            return;
        }
        messageCode = messageCode.trim();
        if (Object.keys(this._data[lang]).includes(messageCode) != null) {
            return this.parseVars(this._data[lang][messageCode], parameters);
        }
        console.warn('[gkjs.i18n] Message ' + messageCode + ' not found in ' + lang + ' lang');
        if (lang !== this._settings.defaultLanguage) {
            return this.getMessage(messageCode.trim(), parameters, this._settings.defaultLanguage);
        } else {
            return messageCode;
        }
    },

    parseVars: function (message, parameters) {
        if (Array.isArray(parameters)) {
            for (let i = 1; i <= parameters.length; i++) {
                let expression = new RegExp('%%' + i, 'g');
                message = message.replace(expression, parameters[i - 1]);
            }
        }
        return message;
    },
    /** Charge le fichier de langue,
     * et à défaut la langue par défaut.
     */
    loadLanguage: async function (languageCode) {
        if (this._data == null) {
            this._data = {};
        }
        if (gkjs.i18n._data[languageCode] != null) {
            // Already loaded
            return;
        }

        return fetch(this._settings.basePath + languageCode + '.json', {
            method: 'GET',
            mode: 'no-cors'
        }).then(function (response) {
            return response.json()
        }).then(function(json) {
            gkjs.i18n._data[languageCode] = json;
            gkjs.i18n.onChange();
            return json;
        }).catch(function (error) {
            gkjs.i18n._data[languageCode] = {};
            if (languageCode === gkjs.i18n._settings.defaultLanguage) {
                let message = '[gkjs.i18n] Unable to load default language ' + gkjs.i18n._settings.defaultLanguage;
                console.error(message);
                console.info('Status:' + data.status + ' / URL: ' + this.url);
                throw message;
            } else {
                console.warn('[gkjs.i18n] Unable to load language ' + languageCode);
                if (gkjs.i18n._data[gkjs.i18n._settings.defaultLanguage] == null) {
                    gkjs.i18n.loadLanguage(gkjs.i18n._settings.defaultLanguage);
                }
            }
        });
    },
    /** Change de langue d'affichage. */
    changeLanguage: function (languageCode) {
        window.localStorage.lang = languageCode;
        this.loadLanguage(languageCode).then();
    },
    /** Charge toutes les zones à traduire et change son contenu */
    run: function () {
        let _self = this;
        document.querySelectorAll('[i18n]').forEach(function (node) {
            // On prend l'innerHTML plutôt que l'innerText
            // Car l'innerText récupère le texte transformé par la directive CSS textTransform
            let ttt = node.innerHTML.replaceAll(/<[^>]*>/gi, '');
            let trans = null;
            if (ttt.trim() !== '') {
                trans =  _self.getMessage(ttt);
                if (trans !== undefined) {
                    node.innerText = trans;

                } else {
                    console.warn('[gkjs.i18n] Message ' + ttt + ' not found in ' + gkjs.i18n.getLang() + ' lang');
                }
            }

            // Replace in all textual attributes
            const textAttributes = ['placeholder', 'title', 'alt', 'data-original-title', 'data-content'];
            for (let attId in textAttributes) {
                let attName = textAttributes[attId];
                if (node[attName] !== undefined && node[attName].trim() !== '') {
                    trans =  _self.getMessage(node[attName]);
                    if (trans !== undefined) {
                        node[attName] = trans;
                    } else {
                        console.warn('[gkjs.i18n] Message ' + node[attName] + ' not found in ' + lang + ' lang');
                        return;
                    }

                }
            }
            node.attributes.removeNamedItem('i18n');
        });
    },
    init: function () {
        if (window.i18nlang == null) {
            let lang = this.getLang();
            gkjs.i18n.loadLanguage(lang).then((result) => {
                window.i18nlang = lang;
                gkjs.i18n.init();
            });
        } else {
            gkjs.i18n.run();
        }
    }
};

window.addEventListener('load', function () {
    gkjs.i18n.init();
});

if (typeof angular !== 'undefined') {
    angular.module('gkjs', []).filter('i18n', function () {
        return function (input) {
            return __(input);
        };
    });
}
